import { render, staticRenderFns } from "./configBar.vue?vue&type=template&id=2db7b68f&scoped=true"
import script from "./configBar.vue?vue&type=script&lang=js"
export * from "./configBar.vue?vue&type=script&lang=js"
import style0 from "./configBar.vue?vue&type=style&index=0&id=2db7b68f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db7b68f",
  null
  
)

export default component.exports